import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Title class.
 */
export default class ParallaxMedia extends Base {
  breakpoints = ['xxs', 'xs', 's', 'm'];

  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'ParallaxMedia',
    refs: ['media'],
    options: {
      offset: {
        type: Number,
        default: 100,
      },
    },
  };

  /**
   *
   */
  mounted() {
    gsap.set(this.$refs.media, { scale: 1.05, y: this.isMobile ? -10 : -80 });
    this.tween = gsap.to(this.$refs.media, {
      y: this.isMobile ? 10 : this.$options.offset,
      ease: 'none',
      scrollTrigger: {
        trigger: this.$el,
        start: 'top bottom',
        end: this.isMobile ? 'bottom top' : '+180% center',
        markers: false,
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }

  /**
   *
   */
  destroyed() {
    this.tween?.scrollTrigger?.kill();
    this.tween?.kill();
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }
}
